import { Badge, type BadgeVariant } from '@/components/ui/Badge'
import type { PayrollRunStatus, BatchStatus } from '@/features/payroll/types/payroll.types'

type AnyStatus = PayrollRunStatus | BatchStatus | string

const STATUS_VARIANT: Record<string, BadgeVariant> = {
  draft: 'neutral',
  calculated: 'info',
  pending: 'warning',
  consolidated: 'info',
  approved: 'success',
  paid: 'success',
  void: 'danger',
  rejected: 'danger',
}

const STATUS_LABEL: Record<string, string> = {
  draft: 'Draft',
  calculated: 'Calculated',
  pending: 'Pending',
  consolidated: 'Consolidated',
  approved: 'Approved',
  paid: 'Paid',
  void: 'Void',
  rejected: 'Rejected',
}

export interface StatusBadgeProps {
  status: AnyStatus
  className?: string
}

export function StatusBadge({ status, className }: StatusBadgeProps): React.ReactElement {
  return (
    <Badge variant={STATUS_VARIANT[status] ?? 'neutral'} className={className}>
      {STATUS_LABEL[status] ?? status}
    </Badge>
  )
}

StatusBadge.displayName = 'StatusBadge'
